/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */
'use strict';

// Based on the React repo.

module.exports = {
  ASYNC_MODE_NUMBER: 0xeacf,
  ASYNC_MODE_SYMBOL_STRING: 'Symbol(react.async_mode)',
  CONTEXT_CONSUMER_NUMBER: 0xeace,
  CONTEXT_CONSUMER_SYMBOL_STRING: 'Symbol(react.context)',
  CONTEXT_PROVIDER_NUMBER: 0xeacd,
  CONTEXT_PROVIDER_SYMBOL_STRING: 'Symbol(react.provider)',
  STRICT_MODE_NUMBER: 0xeacc,
  STRICT_MODE_SYMBOL_STRING: 'Symbol(react.strict_mode)',
};



/** WEBPACK FOOTER **
 ** /Users/bvaughn/Documents/git/react-devtools/backend/ReactSymbols.js
 **/